import { GenericNotificationModal } from 'src/app/shared/components/generic-notification/generic-notification.component';
import { NotificationBase } from './notification-base';

export class NotificationGeneric extends NotificationBase {
  async process(): Promise<void> {
    if (this.item) {
      const modal = await this.modalCtrl.create({
        component: GenericNotificationModal,
        componentProps: {
          item: this.item,
        },
      });

      // https://github.com/ionic-team/ionic-framework/issues/26872
      modal.shadowRoot.querySelector('.modal-wrapper').removeAttribute('aria-modal');

      modal.present();
    }
  }

  protected viewNotification(): void {}
}
